import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './ListModule.module.scss';

const ListModule = ({ type, listType, header, text, items }) => {
    const Tag = listType === 'links' ? 'div' : type;
    const isNumbered = type === 'ol';

    const listClass = classNames(styles['ListModule__List'], {
        [styles['ListModule__List--Links']]: Tag === 'div',
        [styles['ListModule__List--Numbers']]: isNumbered,
    });

    return (
        <div className={styles['ListModule']}>
            <div className={styles['ListModule__Container']}>
                {header && (
                    <h3 className={[styles['ListModule__Header']]}>{header}</h3>
                )}
                {text && (
                    <div className={[styles['ListModule__Text']]}>{text}</div>
                )}
                <Tag className={listClass}>
                    {items.map((props, idx) => {
                        let text = props.text;

                        if (!text && props.doc && props.doc.doc.title) {
                            text = props.doc.doc.title;
                        }

                        if (!text && props.page && props.page.title) {
                            text = props.page.title;
                        }

                        if (!text && typeof props === 'string') {
                            text = props;
                        }

                        return (
                            <Item
                                href={props.href}
                                text={text}
                                key={idx}
                                isExternal={props.isExternal}
                            />
                        );
                    })}
                </Tag>
            </div>
        </div>
    );
};

const Item = ({ href, text, isExternal }) => {
    const itemClass = classNames(styles['ListModule__Item'], {
        [styles['ListModule__Item--Link']]: href,
        [styles['ListModule__Item--IsExternal']]: isExternal,
        [styles['ListModule__Item--IsInternal']]: !isExternal,
    });

    const Tag = href ? 'a' : 'li';
    let props = {};

    if (href) {
        props.href = href;
    }

    return (
        <Tag className={itemClass} {...props}>
            {text}
        </Tag>
    );
};

ListModule.propTypes = {
    type: PropTypes.string,
    listType: PropTypes.string,
    header: PropTypes.string,
    items: PropTypes.array,
    text: PropTypes.string,
    doc: PropTypes.object,
    page: PropTypes.object,
    href: PropTypes.string,
    isExternal: PropTypes.bool,
};

ListModule.defaultProps = {
    type: '',
    listType: '',
    header: '',
    items: [],
    doc: {},
    page: {},
    text: '',
    href: '',
    isExternal: false,
};

Item.propTypes = {
    href: PropTypes.string,
    text: PropTypes.string,
    isExternal: PropTypes.bool,
};

Item.defaultProps = {
    href: '',
    text: '',
    isExternal: false,
};

export default ListModule;
